/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLens {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLens.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLens>): WellArchitectedFrameworkAwsCustomLens {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLens(), model);
        WellArchitectedFrameworkAwsCustomLens.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLens>): WellArchitectedFrameworkAwsCustomLens {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLens.newInstance(<WellArchitectedFrameworkAwsCustomLens> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLens) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLens.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLens): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLens.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pillars) {
            for (let val of this.pillars) {
                models.WellArchitectedFrameworkAwsCustomLensPillar.fixupPrototype(val);
            }
        }
    }

    /**
     * Schema version of AWS custom lens
     */
    schema_version: string;

    /**
     * Name of AWS custom lens
     */
    name: string;

    /**
     * Description of AWS custom lens
     */
    description: string;

    /**
     * Pillars associated with AWS custom lens
     */
    pillars: Array<models.WellArchitectedFrameworkAwsCustomLensPillar>;

}
